"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CommaNumber = (0, vue_1.resolveComponent)("CommaNumber");
    return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CommaNumber, {
        class: "number-change",
        data: _ctx.currentData,
        color: _ctx.color,
        decimal: _ctx.decimal > 0,
        comma: _ctx.comma,
        format: _ctx.format
    }, null, 8, ["data", "color", "decimal", "comma", "format"]));
}
exports.render = render;
